import { apiSlice } from "./apiSlice";
export const actionTrackerSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllActionTracker: builder.query({
            query: (params) => ({
                url: `ProjectAction`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllActionTracker"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllActionTracker: builder.query({
            query: (params) => ({
                url: `ProjectAction`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getActionTrackerDetail: builder.query({
            query: (req) => ({
                url: `ProjectAction/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addActionTracker: builder.mutation({
            query: (body) => ({
                url: `ProjectAction`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllActionTracker', 'ActionTrackerCount']
        }),
        addActionTrackerComment: builder.mutation({
            query: (body) => ({
                url: `ProjectActionComment`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['allActionTrackerComment']
        }),
        getActionTrackerComments: builder.query({
            query: ({ actionId, ...params }) => ({
                url: `ProjectActionComment/action/${actionId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["allActionTrackerComment"],
        }),
        // getAttachmentsByComment: builder.query({
        //     query: (commentId) => `/ProjectActionComment/${commentId}/attachments`,
        // }),
        getAttachmentsByComment: builder.query({
            query: (commentId) => ({
                url: `ProjectActionComment/${commentId}/attachments`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        editActionTracker: builder.mutation({
            query: (body) => ({
                url: `ProjectAction`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ["AllActionTracker", 'ActionTrackerCount'],
        }),
        // getHistory: builder.query({
        //     query: (req) => ({
        //         url: `Workflow/history`,
        //         params: req,
        //     }),
        //     keepUnusedDataFor: 0,
        //     refetchOnMountOrArgChange: true
        // }),
        getActionTrackerStatusCount: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `ProjectAction/project/${projectId}/summary`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ActionTrackerCount"],
        }),
        getActionTrackerStatusCountByType: builder.query({
            query: ({ projectType, ...params }) => ({
                url: `ProjectAction/${projectType}/summary`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ActionTrackerCount"],
        }),
        deleteActionTracker: builder.mutation({
            query: (id) => ({
                url: `ProjectAction/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllActionTracker']
        }),
        getMyActionTracker: builder.query({
            query: (params) => ({
                url: `ProjectAction/me`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllActionTracker"],
        }),
    }),
});

export const { useEditActionTrackerMutation,
    useGetActionTrackerCommentsQuery,
    useAddActionTrackerCommentMutation,
    useGetAllActionTrackerQuery,
    useLazyGetAllActionTrackerQuery,
    useLazyGetExportAllActionTrackerQuery,
    useAddActionTrackerMutation,
    useGetActionTrackerDetailQuery,
    useGetActionTrackerStatusCountQuery,
    useLazyGetActionTrackerStatusCountQuery,
    useGetAttachmentsByCommentQuery,
    useDeleteActionTrackerMutation,
    useGetActionTrackerStatusCountByTypeQuery, 
    useLazyGetActionTrackerStatusCountByTypeQuery,
    useGetMyActionTrackerQuery,
    useLazyGetMyActionTrackerQuery} = actionTrackerSlice;
